import * as Yup from "yup";
import TextField from "../../../common/components/formFields/TextField";
import Select from "../../../common/components/formFields/Select";
import GroupSelect from "../../../common/components/formFields/GroupSelect";

export function formFields(t, sensorOptions) {
  return [
    {
      size: 12,
      field: (
        <GroupSelect id="sensorId" label="Sensor" options={sensorOptions} />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          id="designation"
          type="text"
          label={t("alerts.AlertForm.form.designation")}
          required={true}
        />
      ),
    },
    {
      size: 12,
      field: (
        <Select
          id="severity"
          label={t("alerts.AlertForm.form.severity")}
          required={true}
          options={[
            {
              value: "HIGH",
              text: t("common.enum.sensorSeverity.HIGH"),
            },
            { value: "MEDIUM", text: t("common.enum.sensorSeverity.MEDIUM") },
            { value: "LOW", text: t("common.enum.sensorSeverity.LOW") },
          ]}
        />
      ),
    },
    {
      size: 12,
      field: (
        <Select
          id="type"
          label={t("alerts.AlertForm.form.type")}
          required={true}
          options={[
            {
              value: "MAX",
              text: t("common.enum.alertType.MAX"),
            },
            { value: "MIN", text: t("common.enum.alertType.MIN") },
            { value: "NULL", text: t("common.enum.alertType.NULL") },
            // { value: "NETWORK", text: t("common.enum.sensorType.NETWORK") },
            // { value: "POWER", text: t("common.enum.sensorType.POWER") },
          ]}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          id="value"
          type="text"
          label={t("alerts.AlertForm.form.value")}
          required={true}
        />
      ),
    },
  ];
}

export function formSchema(t) {
  return Yup.object().shape({
    designation: Yup.string().required(
      t("structure.AlertForm.form.requiredDesignation")
    ),
    description: Yup.string(),
  });
}
